import { Modal } from "react-bootstrap";
import Link from 'next/link';

const NoLoginReview = (props) => {

	return (
        <>
            <Modal.Header style={{'border': '0px'}} closeButton onClick={props.closeModel}></Modal.Header>
			<Modal.Body>
                <p className="text-center">You are trying to write a review without login</p>
                <p className="text-center">You will need to <Link href="/login"><a>login</a></Link> or <Link href="/signup"><a>create a  user account</a></Link> to send and receive messages in this way</p>
			</Modal.Body>	
        </>	
	)
}



export default NoLoginReview
